module.exports = __webpack_public_path__ + "img/drawer.0aa9434a.svg";